import PropTypes from "prop-types";

import AppThemeDialog from "./AccountAppTheme/AppThemeDialog";

import {
  GET_ACCOUNT_APP_CONTENT_QUERY_NAME,
  UPDATE_ACCOUNT_APP_THEME,
} from "graphqlQueries/accountFiles";

const UpdateAccountAppTheme = ({ onClose, accountId, initialData, mode }) => {
  return (
    <AppThemeDialog
      mutation={UPDATE_ACCOUNT_APP_THEME}
      onClose={onClose}
      accountId={accountId}
      initialData={initialData}
      mode={mode}
      isEdit={true}
      refetchQuery={[GET_ACCOUNT_APP_CONTENT_QUERY_NAME]}
    ></AppThemeDialog>
  );
};

UpdateAccountAppTheme.propTypes = {
  onClose: PropTypes.func.isRequired,
  accountId: PropTypes.number.isRequired,
  initialData: PropTypes.object.isRequired,
  mode: PropTypes.string,
};

export default UpdateAccountAppTheme;
